import { useToastBridge } from '@/hooks/use-toast'

// Bridges the app toast() queue onto the Nimbus <Toast.Provider> (mounted in App.tsx).
// Nimbus renders the toasts itself, so this component renders nothing.
export function Toaster() {
  useToastBridge()
  return null
}
